/**
 * 优势案例展示
 */
import * as React from 'react'
import styles from './index.module.less'

export default function Index({ style = {}, url }: any) {
  return (
    <div style={style} className={styles.card}>
      {url && <img draggable={false} loading="lazy" src={url} alt="advantage" />}
    </div>
  )
}
